export function formatStartDateForApi(date) {
    return new Date(new Date(date).setHours(0,0,0,0)).toISOString();
}

export function formatEndDateForApi(date) {
    return new Date(new Date(date).setHours(23,59,59,999)).toISOString();
}